"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var sso_1 = require("./sso");
exports.SSO = sso_1.default;
var sso_store_local_storage_1 = require("./sso-store-local-storage");
exports.SSOStoreLocalStorage = sso_store_local_storage_1.default;
//# sourceMappingURL=index.js.map